// extracted by mini-css-extract-plugin
module.exports = {"chartBox":"TopicChartScatterPlot_chartBox__eqQha","chartTitle":"TopicChartScatterPlot_chartTitle__2rnxl","chart":"TopicChartScatterPlot_chart__3xLw0"};